import React from 'react';
import CommentItem from './CommentItem';
import CommentInput from './CommentInput';
import { Divider } from '@/components/Shared';
import { ICommentSection } from '@/interfaces/comment';
import { Button } from 'antd';

const CommentSection = ({
  onSubmit,
  onDelete,
  dataComment,
  fetchMoreItem,
  hasMoreData,
  totalComment,
  onUpdate,
  onLikeClick,
  onUnLikeClick,
}: ICommentSection) => {
  return (
    <div
      id="Comment"
      className="bg-[#D9DBDE] p-5 lg:p-10 rounded-xl flex flex-col gap-4"
    >
      <p className="font-bold">Bình luận ({totalComment ?? 0})</p>
      <div>
        <CommentInput onSubmit={comment => onSubmit(comment, null, null)} />
      </div>
      <Divider />
      <div>
        {dataComment?.map((item, index) => (
          <CommentItem
            onUnLikeClick={onUnLikeClick}
            key={index}
            data={item}
            onDelete={onDelete}
            onSubmit={onSubmit}
            onUpdate={onUpdate}
            onLikeClick={onLikeClick}
          />
        ))}
        {hasMoreData && (
          <Button
            className="w-full rounded-lg self-center text-[19px] h-fit font-bold text-[#3F4D5C]"
            onClick={fetchMoreItem}
          >
            Xem thêm bình luận
          </Button>
        )}
      </div>
    </div>
  );
};

export default CommentSection;
